angular
    .module('empower.inbox')
    .service('inboxService', ['httpService', '$rootScope','$q','$filter',
        function (httpService, $rootScope, $q, $filter) {
            return {
                getUnreadDocumentCount: getUnreadDocumentCount,
                getWorkerInboxDocuments: getWorkerInboxDocuments,
                updateFavoriteDocument: updateFavoriteDocument,
                viewDocument: viewDocument,
                getClaimDocuments: getClaimDocuments
            };

            function getUnreadDocumentCount() {
                var def = $q.defer(),
                    apiTarget = "api/claims/getunreaddocumentcount",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DateOfBirth: $rootScope.user.DateOfBirth,
                    });
                httpService.httpRequest(apiTarget, values, 'GET').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function getWorkerInboxDocuments(inboxData) {
                var def = $q.defer(),
                    apiTarget = "api/claims/getworkerinboxdocuments",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DateOfBirth: $rootScope.user.DateOfBirth,
                        esSearchCursor: inboxData.esSearchCursor,
                        DocumentPageNumber: inboxData.documentPageNumber,
                        DocumentRowsPerPage: inboxData.documentRowsPerPage,
                        ListCategories: inboxData.filterCategories,
                        ListClaims: inboxData.filterClaims,
                        IsFavoriteOnly: inboxData.isFavoriteOnly,
                        IsIncludeDocumentId: false,
                        IsSortDesc: inboxData.isSortDesc,
                        ReceivedDateFrom: inboxData.receivedDateFrom,
                        ReceivedDateTo: inboxData.receivedDateTo
                    });
                httpService.httpRequest(apiTarget, values, 'GET').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function getClaimDocuments(data) {
                var def = $q.defer(),
                    apiTarget = "api/claims/getnsidocuments",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        ClaimId: data.claimId,
                        DocumentRowsPerPage: data.documentRowsPerPage,
                        DocumentPageNumber: data.documentPageNumber,                    
                        IsClaimant: $rootScope.user.IsClaimant,
                        esSearchCursor: data.esSearchCursor,
                        ListCategories: data.filterCategories,
                        IsFavoriteOnly: data.isFavoriteOnly,
                        IsSortDesc: data.isSortDesc,
                        ReceivedDateFrom: data.receivedDateFrom,
                        ReceivedDateTo: data.receivedDateTo
                    });

                httpService.httpRequest(apiTarget, values, 'GET').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function updateFavoriteDocument(documentName, isFavorite) {
                var def = $q.defer(),
                    apiTarget = "api/claims/updatefavoritedocument",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DateOfBirth: $rootScope.user.DateOfBirth,
                        docId: documentName,
                        isFavorite: isFavorite
                    });
                httpService.httpRequest(apiTarget, values, 'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function viewDocument(document, act) {
               
                var APITarget = "api/claims/viewclaimdocument";
                var Values =
                    {
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DocumentId: document.DocID_
                    };
                Values = JSON.stringify(Values);
                var options = { responseType: 'arraybuffer' };
                httpService.httpRequest(APITarget, Values, 'POST', options).then(function (response) { 
                    document.IsRead_ = true;
                    var file = new Blob([response.File], { type: 'application/pdf' });                   
                  
                    if (act == 1)// open/view in new window
                    {
						if (window.navigator && window.navigator.msSaveOrOpenBlob) {
							window.navigator.msSaveOrOpenBlob(file);
						}
						else {
							var objectUrl = URL.createObjectURL(file);
							window.open(objectUrl);
						}
                        //var fileURL = URL.createObjectURL(file);
                        //window.open(fileURL);
                    }
                    else if (act == 2)
                    {
                        var fileName = document.Name_ + '.pdf';
                        saveAs(file, fileName);
                    }
                });
            };
        }
    ]);